import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail } from "lucide-react";
import { api, wpImg } from "@/lib/api";
import MarkdownView from "@/components/MarkdownView";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  const [settings, setSettings] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/services/${slug}`).then((r) => setS(r.data)).catch(() => setNotFound(true));
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, [slug]);

  if (notFound) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
        <h1 className="font-serif text-4xl text-ink">Service not found</h1>
        <Link to="/services" className="mt-6 text-emerald_deep underline">Back to services</Link>
      </div>
    );
  }
  if (!s) return <div className="min-h-[60vh]" />;

  return (
    <div data-testid="service-detail-page">
      <section className="relative">
        {s.image_url && (
          <div className="relative bg-navy py-16 md:py-24 overflow-hidden">
            <div className="absolute inset-0 pattern-girih opacity-20" />
            <div className="relative max-w-4xl mx-auto px-6 md:px-10 flex flex-col items-center text-center text-cream">
              <Link to="/services" className="self-start inline-flex items-center gap-2 text-cream/80 hover:text-gold text-sm mb-6">
                <ArrowLeft size={14} /> All services
              </Link>
              <div className="w-24 h-24 rounded-3xl bg-cream/10 backdrop-blur border border-cream/20 flex items-center justify-center mb-6">
                <img src={wpImg(s.image_url)} alt={s.title} className="w-14 h-14 object-contain" />
              </div>
              <h1 className="display text-4xl md:text-6xl text-cream max-w-3xl">{s.title}</h1>
            </div>
          </div>
        )}
      </section>
      <section className="py-20 px-6 md:px-10">
        <div className="max-w-4xl mx-auto">
          <p className="font-serif text-2xl md:text-3xl text-ink leading-relaxed italic">{s.summary}</p>
          <div className="ornament-divider my-10"><span className="text-[10px] uppercase tracking-[0.28em] text-gold font-semibold">·</span></div>
          <div className="prose prose-lg max-w-none text-ink/75 leading-relaxed font-light">
            <MarkdownView>{s.description}</MarkdownView>
          </div>
          <div className="mt-12 rounded-3xl bg-emerald_deep text-cream p-10 relative overflow-hidden">
            <div className="absolute inset-0 pattern-girih opacity-20" />
            <div className="relative">
              <h3 className="font-serif text-3xl">Get in touch</h3>
              <p className="mt-3 text-cream/80 font-light">Have questions about this service? Our team is here to help.</p>
              <div className="mt-6 flex flex-wrap gap-4">
                {settings?.phone && (
                  <a href={`tel:${settings.phone}`} className="inline-flex items-center gap-2 rounded-full bg-gold text-emerald_deep px-6 py-3 text-sm font-semibold">
                    <Phone size={14} /> {settings.phone}
                  </a>
                )}
                <Link to="/contact" className="inline-flex items-center gap-2 rounded-full border border-cream/30 text-cream px-6 py-3 text-sm font-medium hover:bg-cream/10">
                  <Mail size={14} /> Send a message
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
